<template>
  <div class="input-group">
    <flat-pickr
      v-model="date"
      :config="config"
      class="form-control"
      placeholder="Vyber datum"
      name="date">
    </flat-pickr>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/themes/dark.css';

export default {
  name: 'DateInput',
  data() {
    return {
      // Initial value
      date: new Date(),
      // Get more form https://chmln.github.io/flatpickr/options/
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'd.m.Y',
        altInput: true,
        dateFormat: 'd.m.Y',
      },
    };
  },
  components: {
    flatPickr,
  },
};
</script>

<style scoped>

</style>
